import React, { useCallback } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { htmltoText } from '@/common/functions';
import { tinymceKey } from '@/common/config/keys';
const TextArea = (props) => {
    const { name, value, onChange, onInit, count = 0, limit, init } = props;
    const renderLimit = useCallback(() => {
        const countClass = limit && count && count > limit ? 'danger' : '';
        if (limit) {
            return (React.createElement("div", { className: `text-end ${countClass}` },
                React.createElement("span", null, count),
                " / ",
                React.createElement("span", null, limit)));
        }
        return null;
    }, [count, limit]);
    return (React.createElement("div", null,
        React.createElement(Editor, { textareaName: name, apiKey: tinymceKey, value: value, init: {
                height: 250,
                menubar: false,
                statusbar: false,
                paste_preprocess: function (plugin, args) {
                    args.content = htmltoText(args.content);
                },
                paste_data_images: false,
                paste_block_drop: true,
                plugins: ['link', 'paste', 'wordcount'],
                toolbar: 'undo redo | bold italic | \
						alignleft aligncenter alignright | \
						| link',
                ...init,
            }, onEditorChange: onChange, onInit: onInit }),
        renderLimit()));
};
export default TextArea;
